"use client";

import React, { useEffect, useState, Suspense, lazy } from "react";
import { Box, Typography } from "@mui/material";

const Chart = lazy(() => import("react-apexcharts"));

const UserDistribution = ({ data = [] }) => {
  const [isChartLoaded, setChartLoaded] = useState(false);

  useEffect(() => {
    setChartLoaded(true);
  }, []);

  // Extract user classification data
  const userTypes = (data || []).map(item => item.user_type || 'Unknown');
  const percentages = (data || []).map(item => parseFloat(item.percentage) || 0);

  // Donut Chart Data - User Classification
  const donutSeries = percentages.length > 0 ? percentages : [0];
  const donutLabels = userTypes.length > 0 ? userTypes.map(t => t.charAt(0).toUpperCase() + t.slice(1) + ' Users') : ['No Data'];

  const donutOptions = {
    chart: { type: 'donut' },
    labels: donutLabels,
    colors: ['#605DFF', '#4ECDC4'],
    legend: {
      position: 'bottom'
    },
    dataLabels: { enabled: true }
  };

  return (
    <Box>
      <Typography variant="h6" fontWeight={700} mb={2} className="text-black">
        User Distribution
      </Typography>
      <Box sx={{ height: 300 }}>
        {isChartLoaded && (
          <Suspense fallback={<div>Loading...</div>}>
            <Chart options={donutOptions} series={donutSeries} type="donut" height={300} />
          </Suspense>
        )}
      </Box>
    </Box>
  );
};

export default UserDistribution;

